// src/components/Hero.js
import React, { useState, useEffect } from 'react'; // Import useState and useEffect

function Hero() {
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);

  // Effect to hide scroll indicator on scroll
  useEffect(() => {
    const handleScroll = () => {
      // Hide indicator if user scrolled down a bit (e.g., 50px)
      if (window.scrollY > 50) {
        setShowScrollIndicator(false);
      } else {
        // Optional: Show it again if they scroll back to the very top
        // setShowScrollIndicator(true);
      }
    };

    // Add listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array means this runs once on mount and cleans up on unmount

  return (
    <section id="hero" className="section hero-section">
      <div className="container">
        <div className="hero-text-container">
          {/* Add class "fade-in-content" for animation targeting */}
          <div className="hero-text-content fade-in-content">
            <h1>
              Willkommen bei{' '}
              <span className="hero-h1-highlight">JS-Plott-Design</span>
            </h1>
            <p>
              Wir bringen deine Ideen auf T-Shirts, Tassen, Textilien und vieles
              mehr – schnell, hochwertig und individuell. Entfalte deine
              Kreativität, wir kümmern uns um die Technik!
            </p>
          </div>
        </div>
      </div>

      {/* Scroll Down Indicator */}
      {showScrollIndicator && (
        <div className="scroll-indicator" aria-hidden="true">
          {/* Simple arrow using borders */}
          <span className="scroll-arrow"></span>
        </div>
      )}
    </section>
  );
}

export default Hero;